<div class="panel">
    <div class="panel-header">
        <div class="panel-title"><h2>About Custom Deal Types</h2></div>
        <p>
            You can build custom deal types in advance to expedite the process of creating Deal Jackets. Each custom deal type will include the standard forms
            and documents associated with a specific type of deal. For example, you can build a custom deal type with the documents typically used for a new car
            purchase with trade-in, and one for a used car purchase without trade-in. You can also create custom deal types to include the specific paperwork
            for various financial institutions.
        </p>
        <p>
            There is no limit to the number and type of custom deal types you can create; however, we recommend limiting custom deal types to those that are
            used fairly frequently and/or by multiple people. Once a Deal Jacket is created, you can add any missing forms by clicking the Add F&I Form button
            in the jacket. You can also delete unnecessary documents and forms by clicking the trashcan icon next to the form name. Making minor adjustments to
            the documents in Deal Jackets after a deal has been created is likely to be more manageable than having multiple custom deal types that only differ
            by one or two forms.
        </p>
        <p>By default, all custom deal types will include the e-sign consent forms for the buyer and Co-Buyer, which are required for every Deal Jacket.</p>
        <p>
            Changes to custom deal types will not impact any existing Deal Jackets. They will only be applied to Deal Jackets created after the deal type has
            been updated. Deleting a custom deal type will not remove it from any existing Deal Jackets.
        </p>
    </div>

    
            <!-- <div class="video-section">
                <div (click)="openVideo('Custom Deal Types Overview', 'CustomDealTypesOverview.mp4')" class="image-wrap">
                    <div class="image-overlay">
                        <mat-icon class="play-icon">play_circle_outline</mat-icon>
                    </div>
                    <video [src]="this.envVideoUrl + 'CustomDealTypesOverview.mp4'"></video>
                </div>
                <div class="video-text">
                    <h3>Creating and Managing Custom Deal Types</h3>
        
                    <p>
                        {{ isReadMore ? fullDesc : shortDesc }}
                        <button *ngIf="fullDesc.length >= 200" class="read-more-btn" (click)="readMore()">
                            {{ isReadMore ? 'Read Less' : 'Read More...' }}
                        </button>
                    </p>
        
                    <button (click)="openVideo('Custom Deal Types Overview', 'CustomDealTypesOverview.mp4')" class="extension-btn">See Video</button>
                </div>
            </div> -->
            <div class="panel-body">
                <h3>Creating and Managing Custom Deal Types</h3>
                <p>Before creating a custom deal type, make sure you have set up the required forms and documents in the F&I Forms library. To add a custom deal type, click the Create Custom Deal Type button and give the deal type a name. Use a unique and descriptive name so you can easily find it when you are creating a Deal Jacket. Then select all the F&I Forms you want to include in the deal type by checking the boxes next to each form name. To modify an existing custom deal type, select it from the list and then make the necessary changes. You can also delete custom deal types no longer in use. Watch the video for a step-by-step demonstration of these processes.</p>
        <div class="highlight">
            Pro tip: Periodically review your custom deal types and make any necessary changes, including deleting deal types you no longer need.
        </div>
    </div>
</div>
